import React, { useState, useEffect } from "react";
import "./App.css";
import Header from "./Components/Header";
import Contact from "./Components/Contact";

const App = () => {
  const [myData, setMyData] = useState({});

  const getResumeData = () => {
    const data = {
      main: {
        name: "Nandeeshwar Kodihalli",
        description: "Software Engineer & Technology Enthusiast",
        image: "nbk.jpg",
        email: "contact[at]n9r[dot]org",
        website: "http://www.n9r.org",
        social: [
          {
            name: "linkedin",
            url: "https://www.linkedin.com/in/nandeeshbk/",
            className: "fa fa-linkedin",
          },
          {
            name: "twitter",
            url: "https://twitter.com/nandeesh",
            className: "fa fa-twitter",
          },
          {
            name: "facebook",
            url: "https://www.facebook.com/nandeeshwar",
            className: "fa fa-facebook",
          },
        ],
      },
    };

    setMyData(data);
  };

  useEffect(() => {
    getResumeData();
  }, []);

  return (
    <div className="App">
      <Header data={myData.main} />
      <Contact data={myData.main} />
    </div>
  );
};

export default App;
